import React from 'react';
import Icon from '../../../components/AppIcon';

const UserDirectory = ({ users, selectedUser, onUserSelect, loading }) => {
  const getRoleColor = (role) => {
    const colors = {
      administrator: 'text-error',
      manager: 'text-warning-foreground',
      supervisor: 'text-primary',
      coordinator: 'text-muted-foreground'
    };
    return colors?.[role] || 'text-muted-foreground';
  };

  const getRoleBadgeColor = (role) => {
    const colors = {
      administrator: 'bg-error/10 text-error',
      manager: 'bg-warning/10 text-warning-foreground',
      supervisor: 'bg-primary/10 text-primary',
      coordinator: 'bg-muted text-muted-foreground'
    };
    return colors?.[role] || 'bg-muted text-muted-foreground';
  };

  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-success',
      inactive: 'bg-muted',
      suspended: 'bg-error'
    };
    return colors?.[status] || 'bg-muted';
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg shadow-elevation-2 border border-border p-24">
        <div className="flex items-center justify-center py-40">
          <Icon name="Loader2" size={32} className="animate-spin" color="var(--color-primary)" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 border border-border">
      <div className="p-24 border-b border-border">
        <h3 className="font-heading text-lg font-semibold text-foreground flex items-center gap-8">
          <Icon name="Users" size={20} color="var(--color-primary)" />
          Team Directory
        </h3>
        <p className="text-sm text-muted-foreground mt-4">
          {users?.length || 0} team members
        </p>
      </div>

      <div className="max-h-[600px] overflow-y-auto">
        {users?.length === 0 ? (
          <div className="p-24 text-center">
            <Icon name="UserX" size={32} color="var(--color-muted-foreground)" />
            <p className="text-muted-foreground mt-12">No users found</p>
          </div>
        ) : (
          users?.map((user) => (
            <div
              key={user?.id}
              onClick={() => onUserSelect(user)}
              className={`p-16 border-b border-border cursor-pointer transition-colors hover:bg-accent ${
                selectedUser?.id === user?.id ? 'bg-accent' : ''
              }`}
            >
              <div className="flex items-start gap-12">
                <div className="relative">
                  {user?.avatar_url ? (
                    <img
                      src={user?.avatar_url}
                      alt={user?.full_name || 'User avatar'}
                      className="w-[40px] h-[40px] rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-[40px] h-[40px] rounded-full bg-primary/10 flex items-center justify-center">
                      <Icon name="User" size={20} color="var(--color-primary)" />
                    </div>
                  )}
                  <div
                    className={`absolute bottom-0 right-0 w-[10px] h-[10px] rounded-full border-2 border-card ${
                      getStatusColor(user?.status)
                    }`}
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-8 mb-4">
                    <h4 className="font-medium text-foreground text-sm truncate">
                      {user?.full_name || 'Unknown User'}
                    </h4>
                  </div>
                  <p className="text-xs text-muted-foreground truncate mb-6">
                    {user?.email}
                  </p>
                  <div className="flex items-center gap-8">
                    <span
                      className={`text-xs px-8 py-2 rounded-full font-medium ${
                        getRoleBadgeColor(user?.role)
                      }`}
                    >
                      {user?.role?.charAt(0)?.toUpperCase() + user?.role?.slice(1)}
                    </span>
                    {user?.department && (
                      <span className="text-xs text-muted-foreground">
                        {user?.department}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UserDirectory;